export var Gender;
(function (Gender) {
    Gender["Male"] = "male";
    Gender["Female"] = "female";
})(Gender || (Gender = {}));
export var GenderBaby;
(function (GenderBaby) {
    GenderBaby["Male"] = "male";
    GenderBaby["Female"] = "female";
    GenderBaby["Surprise"] = "surprise";
})(GenderBaby || (GenderBaby = {}));
const FOR_HUMANS = {
    [Gender.Male]: "férfi",
    [Gender.Female]: "nő",
};
const FOR_HUMANS_BABY = {
    [GenderBaby.Male]: "Fiú",
    [GenderBaby.Female]: "Lány",
    [GenderBaby.Surprise]: "Maradjon meglepetés",
};
export const getGenderChoices = (selected) => Object.values(Gender)
    .map((gender) => ({
    key: gender,
    text: FOR_HUMANS[gender],
    isSelected: gender === selected,
}))
    .sort(({ text: a }, { text: b }) => a.localeCompare(b));
export const genderForHumans = (gender) => FOR_HUMANS[gender];
export const genderBabyForHumans = (gender) => FOR_HUMANS_BABY[gender];
